import React, { ButtonHTMLAttributes, FunctionComponent } from 'react';

import BaseButton from '../BaseButton';
import styleClassNames from './styles.module.scss';

interface TertiaryButtonProps {
  icon?: string;
  iconSize?: number;
  isLoading?: boolean;
  loadingCopy?: string;
  size?: ButtonSize;
}

type ButtonSize = 'small' | 'medium' | 'large';

const TertiaryButton: FunctionComponent<TertiaryButtonProps & ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => {
  const baseProps = {
    ...props,
    styleClassNames,
    variantName: 'tertiary',
  };

  return <BaseButton {...baseProps} />;
};

export default TertiaryButton;
